export * from './deprecated'


// WEBPACK FOOTER //
// ./src/decorators/index.js